import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FindAnswersComponent } from './find-answers/find-answers.component';
import { FindAnswersRouting } from './find-answers-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from '../shared/primeng.module';
import { MaterialModuleModule } from '../material-module/material-module/material-module.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ScrollNavigationComponent } from './scroll-navigation/scroll-navigation.component';



@NgModule({
  declarations: [
    FindAnswersComponent,
    ScrollNavigationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    PrimengModule,
    MaterialModuleModule,
    MatTooltipModule,
    FindAnswersRouting
  ]
})
export class FindAnswersModule { }
